var map = {
	"./ChooseFile.svg": "./packages/survey-core/src/images-v2/ChooseFile.svg",
	"./ModernBooleanCheckChecked.svg": "./packages/survey-core/src/images-v2/ModernBooleanCheckChecked.svg",
	"./ModernBooleanCheckInd.svg": "./packages/survey-core/src/images-v2/ModernBooleanCheckInd.svg",
	"./ModernBooleanCheckUnchecked.svg": "./packages/survey-core/src/images-v2/ModernBooleanCheckUnchecked.svg",
	"./ModernCheck.svg": "./packages/survey-core/src/images-v2/ModernCheck.svg",
	"./ModernRadio.svg": "./packages/survey-core/src/images-v2/ModernRadio.svg",
	"./ProgressButton.svg": "./packages/survey-core/src/images-v2/ProgressButton.svg",
	"./RemoveFile.svg": "./packages/survey-core/src/images-v2/RemoveFile.svg",
	"./TimerCircle.svg": "./packages/survey-core/src/images-v2/TimerCircle.svg",
	"./add-24x24.svg": "./packages/survey-core/src/images-v2/add-24x24.svg",
	"./arrowleft-16x16.svg": "./packages/survey-core/src/images-v2/arrowleft-16x16.svg",
	"./arrowright-16x16.svg": "./packages/survey-core/src/images-v2/arrowright-16x16.svg",
	"./camera-24x24.svg": "./packages/survey-core/src/images-v2/camera-24x24.svg",
	"./camera-32x32.svg": "./packages/survey-core/src/images-v2/camera-32x32.svg",
	"./cancel-24x24.svg": "./packages/survey-core/src/images-v2/cancel-24x24.svg",
	"./check-16x16.svg": "./packages/survey-core/src/images-v2/check-16x16.svg",
	"./check-24x24.svg": "./packages/survey-core/src/images-v2/check-24x24.svg",
	"./chevrondown-24x24.svg": "./packages/survey-core/src/images-v2/chevrondown-24x24.svg",
	"./chevronright-16x16.svg": "./packages/survey-core/src/images-v2/chevronright-16x16.svg",
	"./clear-16x16.svg": "./packages/survey-core/src/images-v2/clear-16x16.svg",
	"./clear-24x24.svg": "./packages/survey-core/src/images-v2/clear-24x24.svg",
	"./close-16x16.svg": "./packages/survey-core/src/images-v2/close-16x16.svg",
	"./close-24x24.svg": "./packages/survey-core/src/images-v2/close-24x24.svg",
	"./collapse-16x16.svg": "./packages/survey-core/src/images-v2/collapse-16x16.svg",
	"./collapsedetails-16x16.svg": "./packages/survey-core/src/images-v2/collapsedetails-16x16.svg",
	"./delete-24x24.svg": "./packages/survey-core/src/images-v2/delete-24x24.svg",
	"./drag-24x24.svg": "./packages/survey-core/src/images-v2/drag-24x24.svg",
	"./draghorizontal-24x16.svg": "./packages/survey-core/src/images-v2/draghorizontal-24x16.svg",
	"./expand-16x16.svg": "./packages/survey-core/src/images-v2/expand-16x16.svg",
	"./expanddetails-16x16.svg": "./packages/survey-core/src/images-v2/expanddetails-16x16.svg",
	"./file-72x72.svg": "./packages/survey-core/src/images-v2/file-72x72.svg",
	"./flip-24x24.svg": "./packages/survey-core/src/images-v2/flip-24x24.svg",
	"./folder-24x24.svg": "./packages/survey-core/src/images-v2/folder-24x24.svg",
	"./fullsize-16x16.svg": "./packages/survey-core/src/images-v2/fullsize-16x16.svg",
	"./image-48x48.svg": "./packages/survey-core/src/images-v2/image-48x48.svg",
	"./loading-48x48.svg": "./packages/survey-core/src/images-v2/loading-48x48.svg",
	"./maximize-16x16.svg": "./packages/survey-core/src/images-v2/maximize-16x16.svg",
	"./minimize-16x16.svg": "./packages/survey-core/src/images-v2/minimize-16x16.svg",
	"./more-24x24.svg": "./packages/survey-core/src/images-v2/more-24x24.svg",
	"./navmenu-24x24.svg": "./packages/survey-core/src/images-v2/navmenu-24x24.svg",
	"./noimage-48x48.svg": "./packages/survey-core/src/images-v2/noimage-48x48.svg",
	"./ranking-arrows.svg": "./packages/survey-core/src/images-v2/ranking-arrows.svg",
	"./rankingundefined-16x16.svg": "./packages/survey-core/src/images-v2/rankingundefined-16x16.svg",
	"./rating-star-2.svg": "./packages/survey-core/src/images-v2/rating-star-2.svg",
	"./rating-star-small-2.svg": "./packages/survey-core/src/images-v2/rating-star-small-2.svg",
	"./rating-star-small.svg": "./packages/survey-core/src/images-v2/rating-star-small.svg",
	"./rating-star.svg": "./packages/survey-core/src/images-v2/rating-star.svg",
	"./reorder-24x24.svg": "./packages/survey-core/src/images-v2/reorder-24x24.svg",
	"./restoredown-16x16.svg": "./packages/survey-core/src/images-v2/restoredown-16x16.svg",
	"./search-24x24.svg": "./packages/survey-core/src/images-v2/search-24x24.svg",
	"./smiley-rate1-24x24.svg": "./packages/survey-core/src/images-v2/smiley-rate1-24x24.svg",
	"./smiley-rate10-24x24.svg": "./packages/survey-core/src/images-v2/smiley-rate10-24x24.svg",
	"./smiley-rate2-24x24.svg": "./packages/survey-core/src/images-v2/smiley-rate2-24x24.svg",
	"./smiley-rate3-24x24.svg": "./packages/survey-core/src/images-v2/smiley-rate3-24x24.svg",
	"./smiley-rate4-24x24.svg": "./packages/survey-core/src/images-v2/smiley-rate4-24x24.svg",
	"./smiley-rate5-24x24.svg": "./packages/survey-core/src/images-v2/smiley-rate5-24x24.svg",
	"./smiley-rate6-24x24.svg": "./packages/survey-core/src/images-v2/smiley-rate6-24x24.svg",
	"./smiley-rate7-24x24.svg": "./packages/survey-core/src/images-v2/smiley-rate7-24x24.svg",
	"./smiley-rate8-24x24.svg": "./packages/survey-core/src/images-v2/smiley-rate8-24x24.svg",
	"./smiley-rate9-24x24.svg": "./packages/survey-core/src/images-v2/smiley-rate9-24x24.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./packages/survey-core/src/images-v2 sync recursive \\.svg$";